import "./styles/main.css";
import { renderApp } from "./app";

const app = document.querySelector<HTMLDivElement>("#app");

if (app) {
  renderApp(app);
}